/**
 * Wrong-year university academic-calendar redirect matching (almanak-n0xc).
 *
 * Dependency-free so it stays unit-testable without the data layer. The public
 * wiring (cache + current-year) lives in slug-university.ts.
 */

export const UNI_YEAR_RANGE_RE = /-\d{4}-\d{4}$/;

/**
 * Strips the trailing `-YYYY-YYYY` range and maps each university stem to a
 * generated slug, preferring the current cycle when several years exist.
 * Returns the current-cycle slug for a wrong-year request, or null when the
 * stem is not a known university (so non-university year-range slugs are
 * unaffected) or the request already matches a generated page.
 */
export function matchUniversityYearRedirect(
  slug: string,
  generatedEnSlugs: ReadonlyArray<{ slug: string; academicYear: number }>,
  currentYear: number,
): string | null {
  if (!UNI_YEAR_RANGE_RE.test(slug)) return null;

  const map: Record<string, string> = {};
  for (const { slug: genSlug, academicYear } of generatedEnSlugs) {
    if (!UNI_YEAR_RANGE_RE.test(genSlug)) continue;
    const genStem = genSlug.replace(UNI_YEAR_RANGE_RE, '');
    if (!map[genStem] || academicYear === currentYear) map[genStem] = genSlug;
  }

  const target = map[slug.replace(UNI_YEAR_RANGE_RE, '')];
  return target && target !== slug ? target : null;
}
